import React from 'react';
import TaxServicesPackageGroup from './taxServices-package-group';

const registrationPackages = [
	{
		label: 'Tax Payer Registration',
		price: 'LKR 1,700',
		name: 'TIN registration',
		features: [
			'Obtaining your (IRD) PIN',
			'Tax Type Registration and advice',
			'Registration Confirmation follow up',
			'Updating taxpayer profile',
		],
	},
	{
		label: 'Tax Payer Registration',
		price: 'LKR 25,400',
		name: 'VAT registration',
		features: [
			'Document preparation',
			'Coordination between IRD and the taxpayer',
			'Advice on VAT Registration',
			'Advice on Tax responsibilities and obligations',
			'VAT Registration',
		],
	},
];

export default function RegistrationPackages({ onRequest }) {
	return (
		<TaxServicesPackageGroup packages={registrationPackages} onRequest={onRequest}
		/>
	);
}